import { FormHelperText, Stack } from '@mui/material';
import _ from 'lodash';

import { api } from 'common';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSelectField } from '../../../ConfigFields/SelectField';

export function UpdatePaymentFormFields() {
  return (
    <Stack gap={2}>
      <BlockValueTemplateField
        fieldName="config.encounterId"
        label="Encounter Id"
        helperText="Enter the reference to the Encounter - e.g. `{{encounter.data.encounterId}}`"
        placeholder="e.g. {{start.data.encounterId}}"
      />
      <FormHelperText>The Encounter ID should be a valid UUID string</FormHelperText>
      <BlockSelectField
        label="Fee type"
        fieldName="config.feeType"
        required
        options={Object.keys(api.FlowDefinition.UpdatePaymentFeeType.enum).map((feeType) => ({
          label: _.startCase(feeType),
          value: feeType,
        }))}
      />
      <BlockValueTemplateField fieldName="config.feeAmount" label="Fee amount" />
      <FormHelperText>Fee amount is in US dollars.</FormHelperText>
    </Stack>
  );
}
